import { ROSTER_CSV_FORMATS } from '@/utils/constants';
import { Vue, Component, Prop } from 'vue-property-decorator';

@Component({
    name: 'oneroster1',
    components: {},
})

export default class OneRoster1 extends Vue {
    @Prop()
    private ssoDetails: any;

    private rosterFormat: any = ROSTER_CSV_FORMATS;
}
